import {useGet} from '../../../../api';

export type ShadowAdminsReportStateDto = {
    shadowAdminsReportFileName: string;
    shadowAdminsReportDate: string;
    isShadowAdminsReportAvailable: boolean;
};

export const useGetShadowAdminsReportState = () => {
    const { data, error } = useGet<ShadowAdminsReportStateDto>({
        url: `/insights/shadowAdminsReportState`
    });

    const reportState = data?.isShadowAdminsReportAvailable ? data : null;

    return { reportState, error };
};
